export default [
  {
    path: "/management/notifications",
    name: "Notifications",
    component: () =>
      import(
        "@/modules/activity-management/notifications/views/Notifications.vue"
      ),
  },
  {
    path: "/management/manage-app",
    name: "ManageApp",
    component: () =>
      import(
        "@/modules/activity-management/manage-app/views/ManageAppList.vue"
      ),
  },
];
